const overrides = {
  'TOTAL BALANCE': 'Current Card Balance',
  'SPENT TODAY': 'Spent today'
};

export default overrides;
